export default "__VITE_ASSET__vfvOHDzCvCvWBc6b9K0Pew__"